import { LiHTMLAttributes, MouseEventHandler } from 'react';
import { joinClassNames } from '../../utils';
import { Icon, IconName } from '../Graphics';
import styles from './styles.module.scss';

type NavItemBadgeProps = {
  value: number;
};

const NavItemBadge = ({ value }: NavItemBadgeProps) => <span className={styles.badge}>{value}</span>;

type NavItemIconProps = {
  icon: IconName;
};

const NavItemIcon = ({ icon }: NavItemIconProps) => (
  <>
    <Icon name={icon} size="0.8em" />{' '}
  </>
);

type NavContentProps = {
  icon?: IconName;
  label: string;
  badgeValue?: number;
};

const NavContent = ({ icon, label, badgeValue }: NavContentProps) => (
  <>
    {icon && <NavItemIcon icon={icon} />}
    {label} {badgeValue && <NavItemBadge value={badgeValue} />}
  </>
);

export type NavItemProps = LiHTMLAttributes<HTMLLIElement> & {
  label: string;
  badgeValue?: number;
  isActive?: boolean;
  link?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  icon?: IconName;
};

export const NavItem = ({ label, badgeValue, isActive = false, link = '', onClick, icon }: NavItemProps) => (
  <li className={joinClassNames(styles.navItem, isActive && styles.active)}>
    {link ? (
      <a href={link}>
        <NavContent icon={icon} label={label} badgeValue={badgeValue} />
      </a>
    ) : (
      <button onClick={onClick}>
        <NavContent icon={icon} label={label} badgeValue={badgeValue} />
      </button>
    )}
  </li>
);
